import { useEffect, useState } from 'react';
import SelectionEdit from '@segmentation/UI/SelectionEdit.tsx';
import { ControlsUI } from '@segmentation/UI/ControlsUI.tsx';
import { GumEditUI } from '@segmentation/UI/GumEditUI.tsx';
import { SelectionUI } from '@segmentation/UI/SelectionUI.tsx';
import { SegmentationProcessingOverlay } from '@segmentation/UI/SegmentationProcessingOverlay.tsx';
import { SegmentationPhase } from '@segmentation/store/segmentationStore.ts';
import useSegmentationStore from '@segmentation/hooks/useSegmentationStore.ts';
import { threeInteractionStore } from '@modules/three/store/threeInteractionStore';

export const SegmentationUI = () => {
  const { segmentationPhase, devReadyJaw, setDevReadyJaw, setSegmentationPhase } = useSegmentationStore();
  const [isSelected, setIsSelected] = useState(false);
  const [jaw, setJaw] = useState<'upper' | 'lower'>('lower');

  useEffect(() => {
    if (!devReadyJaw) return;
    setJaw(devReadyJaw);
    setIsSelected(true);
    setSegmentationPhase(
      devReadyJaw === 'lower'
        ? SegmentationPhase.TEETH_SELECTION_LOWER
        : SegmentationPhase.TEETH_SELECTION_UPPER,
    );
    threeInteractionStore.getState().setPointAdding(false);
    setDevReadyJaw(null);
  }, [devReadyJaw, setDevReadyJaw, setSegmentationPhase]);

  const isSelectionPhase =
    segmentationPhase === SegmentationPhase.TEETH_SELECTION_LOWER || segmentationPhase === SegmentationPhase.TEETH_SELECTION_UPPER;

  return (
    <>
      <SegmentationProcessingOverlay />
      <div className="pointer-events-none absolute inset-0 z-10 flex items-start justify-start p-6">
        <div className="pointer-events-auto flex w-full max-w-sm flex-col gap-4">
          {segmentationPhase === SegmentationPhase.NONE && <ControlsUI />}
          {(segmentationPhase === SegmentationPhase.GUM_EDIT_LOWER ||
            segmentationPhase === SegmentationPhase.GUM_EDIT_UPPER) && <GumEditUI />}
          {isSelectionPhase && (
            <>
              {isSelected ? (
                <SelectionEdit setIsSelected={setIsSelected} setJaw={setJaw} jaw={jaw} />
              ) : (
                <SelectionUI setIsSelected={setIsSelected} jaw={jaw} />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
